/* global axios */
import ApiClient from './ApiClient';

// Helper to build params object for API calls
export const buildContactParamsObject = (page, sortAttr, label, search) => {
  const params = {
    include_contact_inboxes: false,
    page,
    sort: sortAttr,
  };
  if (search) {
    params.q = search;
  }
  if (label) {
    params['labels[]'] = label;
  }
  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '') {
    return axios.get(this.url, {
      params: buildContactParamsObject(page, sortAttr, label, ''),
    });
  }

  show(id, includeCrmSummary = false) {
    const params = {
      include_contact_inboxes: false,
    };
    if (includeCrmSummary) {
      params.include_crm_summary = true;
    }
    return axios.get(`${this.url}/${id}`, { params });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      params: { include_contact_inboxes: false },
    });
  }

  getConversations(contactId) {
    return axios.get(`${this.url}/${contactId}/conversations`);
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  search(search = '', page = 1, sortAttr = 'name', label = '') {
    return axios.get(`${this.url}/search`, {
      params: buildContactParamsObject(page, sortAttr, label, search),
    });
  }

  active(page = 1, sortAttr = 'name') {
    return axios.get(`${this.url}/active`, {
      params: buildContactParamsObject(page, sortAttr, '', ''),
    });
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'name', queryPayload) {
    return axios.post(`${this.url}/filter`, queryPayload, {
      params: buildContactParamsObject(page, sortAttr, '', ''),
    });
  }

  importContacts(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroyCustomAttributes(contactId, customAttributes) {
    return axios.post(`${this.url}/${contactId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAvatar(contactId) {
    return axios.delete(`${this.url}/${contactId}/avatar`);
  }

  exportContacts(queryPayload) {
    return axios.post(`${this.url}/export`, queryPayload);
  }
}

export default new ContactAPI();
